import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useLocation, useNavigate } from 'react-router-dom';
import routes from '../../../routes';
import {
  COURSE_CATEGORIES_GET,
  CATALOGS_GET,
  COURSE_LIST_RESET,
  COURSE_CATEGORIES_RESET,
} from '../../redux/actions/courselist';
import ModalLeaveCourse from '../../../ui/atoms/Modals/ModalLeaveCourse';
import ModalSurvey from '../../../ui/atoms/Modals/ModalSurvey';
import CourseListNational from './National';
import CourseListLocal from './Local';

const CourseList = ({
  catalogs,
  getCatalogs,
  resetCategories,
  getCategories,
  courseListReset,
}) => {
  const navigate = useNavigate();
  const { pathname: categoryLabel } = useLocation();
  const [currentCatalog, setCurrentCatalog] = useState({});

  useEffect(() => {
    courseListReset();
    if (catalogs.length <= 0) getCatalogs();
    return () => {
      setCurrentCatalog({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryLabel]);

  // check if categoryLabel matches one of category labels (from categoryList)
  useEffect(() => {
    if (catalogs.length > 0) {
      const label = categoryLabel?.split('/')[3]?.replace(/ /g, '') || '';
      if (!label) navigate(routes.home.path);
      const category = catalogs?.find((c) =>
        c?.name
          ?.replace(/ /g, '')
          ?.toLowerCase()
          ?.includes(label?.toLowerCase())
      );
      if (category?.id) setCurrentCatalog(category);
      else navigate(routes.home.path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogs, categoryLabel]);

  useEffect(() => {
    if (currentCatalog?.id) {
      resetCategories();
      getCategories({ catalog_id: currentCatalog.id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCatalog]);

  return (
    <>
      {categoryLabel?.split('/')[3]?.includes('nazionale') ? (
        <CourseListNational
          currentCatalog={currentCatalog}
          currentPath={categoryLabel}
        />
      ) : (
        <CourseListLocal
          currentCatalog={currentCatalog}
          currentPath={categoryLabel}
        />
      )}
      <ModalLeaveCourse />
      <ModalSurvey />
    </>
  );
};

CourseList.propTypes = {
  // HOC (connect, state)
  catalogs: PropTypes.array.isRequired,
  // HOC (connect, dispatch)
  getCatalogs: PropTypes.func.isRequired,
  resetCategories: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  courseListReset: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const { catalogs } = state.courselist;
    return {
      catalogs,
    };
  },
  (dispatch) => ({
    courseListReset: () => dispatch({ type: COURSE_LIST_RESET }),
    getCatalogs: () => dispatch({ type: CATALOGS_GET._REQUEST }),
    resetCategories: () => dispatch({ type: COURSE_CATEGORIES_RESET }),
    getCategories: (filters) =>
      dispatch({ type: COURSE_CATEGORIES_GET._REQUEST, filters }),
  })
)(CourseList);
